document.addEventListener("click", (event) => {

  const button = event.target.closest(".winter-offers__copy-btn");
  if (!button) return;

  const code = button.getAttribute("data-copy-code");
  if (!code) return;

  const originalText = button.getAttribute("data-original-text") || button.textContent.trim();
  button.setAttribute("data-original-text", originalText);

  const finishCopy = () => {
    button.textContent = "Copied!";
    button.classList.add("is-copied");

    clearTimeout(button._winterCopyTimeout);
    button._winterCopyTimeout = setTimeout(() => {
      button.textContent = originalText;
      button.classList.remove("is-copied");
    }, 2000);
  };

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(finishCopy).catch(() => {
      fallbackCopy(code);
      finishCopy();
    });
  } else {
    fallbackCopy(code);
    finishCopy();
  }

});

function fallbackCopy(text) {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  try {
    document.execCommand("copy");
  } catch (err) {
    // silently ignore if copy fails
  }
  document.body.removeChild(textarea);
}